import { ReportService } from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";
import { get } from "vue-cookie";

const ReportModule = {
    namespaced: true,
    state: {
        report_payment: [],
        report_sale_channel: [],
        report_product: [],
        report_salechannel_product: [],
        report_user: [],
        report_datum: 0,
        report_user_team: [],
        report_user_product: [],
        report_wms_summary: [],
        report_wms_product_summary: [],
        report_wms_shipping_user: [],
        report_wms_user: [],
        report_wms_sale_channel: [],
		report_wms_state: 0 ,
		report_order_return:[],
    },
    mutations: {
        SET_REPORT_PAYMENT(state, data) {
            state.report_payment = data;
        },

        SET_REPORT_SALE_CHANNEL(state, data) {
            state.report_sale_channel = data;
        },

        SET_REPORT_PRODUCT(state, data) {
            state.report_product = data;
        },

        SET_REPORT_USER(state, data) {
            state.report_user = data;
        },

        SET_REPORT_USER_PRODUCT(state, data) {
            state.report_user_product = data;
        },

        SET_REPORT_DATUM(state, data) {
            state.report_datum = data;
        },

        SET_REPORT_USER_TEAM(state, data) {
            state.report_user_team = data;
        },

        SET_REPORT_WMS_SUMMARY(state, data) {
            state.report_wms_summary = data;
        },

        SET_REPORT_WMS_PRODUCT_SUMMARY(state, data) {
            state.report_wms_product_summary = data;
        },
        SET_REPORT_WMS_SHIPPING_USER(state, data) {
            state.report_wms_shipping_user = data;
        },
        SET_REPORT_WMS_USER(state, data) {
            state.report_wms_user = data;
        },
        SET_REPORT_WMS_SALE_CHANNEL(state, data) {
            state.report_wms_sale_channel = data;
        },
		SET_REPORT_WMS_STATE(state, data) {
			state.report_wms_state = data;
		},
		SET_REPORT_SALECHANNEL_PRODUCT(state, data) {
			state.report_salechannel_product = data;
		},
		SET_REPORT_ORDER_RETURN(state, data) {
			state.report_order_return = data;
		}
    },
    actions: {
        listCommission({ commit, state }, data) {
            return ReportService.ReportCommission(data);
        },
        async listReportPayment({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportPayment(data);
                swal.close();
                commit(
                    "SET_REPORT_PAYMENT",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_PAYMENT", []);
            }
        },

        async listReportSaleChannel({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportSaleChannel(data);
                swal.close();
                commit(
                    "SET_REPORT_SALE_CHANNEL",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_SALE_CHANNEL", []);
            }
        },
		async listReportSaleChannelProduct({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportSaleChannelProduct(data);
                swal.close();
                commit(
                    "SET_REPORT_SALECHANNEL_PRODUCT",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_SALECHANNEL_PRODUCT", []);
            }
        },
        async listReportProduct({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportProduct(data);
                swal.close();
                commit(
                    "SET_REPORT_PRODUCT",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_PRODUCT", []);
            }
        },

        async listReportUser({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportUser(data);
                swal.close();
                commit(
                    "SET_REPORT_USER",
                    response.data.Data == undefined ? [] : response.data.Data
                );
                commit(
                    "SET_REPORT_DATUM",
                    response.data.Datum == undefined ? [] : response.data.Datum
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_USER", []);
            }
        },

        async listReportUserProduct({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportUserAndProduct(data);
                swal.close();
                commit(
                    "SET_REPORT_USER_PRODUCT",
                    response.data.Data == undefined ? [] : response.data.Data
                );
                commit(
                    "SET_REPORT_DATUM",
                    response.data.Datum == undefined ? [] : response.data.Datum
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_USER_PRODUCT", []);
            }
        },

        async listReportUserTeam({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportUserTeam(data);
                swal.close();
                commit(
                    "SET_REPORT_USER_TEAM",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_USER_TEAM", []);
            }
        },
		async listReportOrderReturn({ commit, state }, data) {
            swal.fire({
                title: i18n.t(`processing`),
                type: "info",
                allowEscapeKey: false,
                allowOutsideClick: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            try {
                const response = await ReportService.ReportOrderReturn(data);
                swal.close();
                commit(
                    "SET_REPORT_ORDER_RETURN",
                    response.data.Data == undefined ? [] : response.data.Data
                );
            } catch (err) {
                swal.close();
                console.log(err);
                swal.fire({
                    title: i18n.t(err.response.data.Msg),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                commit("SET_REPORT_ORDER_RETURN", []);
            }
        },
        listReportDashboard({ commit, state }, data) {
            return ReportService.ReportDashboard(data);
        },

        listReportDashboardByPlatformChannel({ commit, state }, data) {
            return ReportService.ReportDashboardByPlatformChannel(data);
        },

        async listReportSummaryWmsProduct({ commit, state }, data) {

            let wms = [];
            let product = [];
            let shipping_user = [];
            let user = [];
            let sale_channel = [];

			

			const response = await ReportService.ReportSummaryWmsProductAsync(data);
			console.log("Report Response",response.data.Datum)
			commit("SET_REPORT_WMS_STATE",response.data.Datum.state)

			if (response.data.Datum.state == 0) {
				return
			}

			if (response.data.Datum.wms != null) {
				wms = response.data.Datum.wms.sort(
					(a, b) => a.amount - b.amount
				);
			}

			if (response.data.Datum.sale_channel != null) {
				sale_channel = response.data.Datum.sale_channel.sort(
					(a, b) => a.amount - b.amount
				);
			}

			if (response.data.Datum.product != null) {
				product = response.data.Datum.product.sort(
					(a, b) => a.amount - b.amount
				);
			}

			if (response.data.Datum.shipping_user != null) {
				shipping_user = response.data.Datum.shipping_user.sort(
					(a, b) => a.amount - b.amount
				);
			}

			if (response.data.Datum.user != null) {
				user = response.data.Datum.user.sort(
					(a, b) => a.amount - b.amount
				);
			}

			commit("SET_REPORT_WMS_SUMMARY", wms);
			commit("SET_REPORT_WMS_PRODUCT_SUMMARY", product);
			commit("SET_REPORT_WMS_SHIPPING_USER", shipping_user);
			commit("SET_REPORT_WMS_USER", user);
			commit("SET_REPORT_WMS_SALE_CHANNEL", sale_channel);

        } ,
		clearReportWms({ commit, state }) {
			commit("SET_REPORT_WMS_SUMMARY", []);
			commit("SET_REPORT_WMS_PRODUCT_SUMMARY", []);
			commit("SET_REPORT_WMS_SHIPPING_USER", []);
			commit("SET_REPORT_WMS_USER", []);
			commit("SET_REPORT_WMS_SALE_CHANNEL", []);
			commit("SET_REPORT_WMS_STATE", 0);
		}
    },
    getters: {
        getReportPayment(state) {
            return state.report_payment;
        },

        getReportSaleChannel(state) {
            return state.report_sale_channel;
        },

        getReportProduct(state) {
            return state.report_product;
        },

        getReportSaleChannelProduct(state) {
            return state.report_salechannel_product;
        },

        getReportUser(state) {
            return state.report_user;
        },

        getReportUserProduct(state) {
            return state.report_user_product;
        },

        getReportUserTeam(state) {
            return state.report_user_team;
        },

        getReportDatum(state) {
            return state.report_datum;
        },

        getReportWmsSummary(state) {
            return state.report_wms_summary;
        },
        getReportWmsProduct(state) {
            return state.report_wms_product_summary;
        },
        getReportWmsShippingUser(state) {
            return state.report_wms_shipping_user;
        },
        getReportWmsUser(state) {
            return state.report_wms_user;
        },
        getReportWmsSaleChannel(state) {
            return state.report_wms_sale_channel;
        },
		getReportWmsState(state){
			return state.report_wms_state;
		},
		getReportOrderReturn(state){
			return state.report_order_return;

		}
    }
};

export default ReportModule;
